export default __webpack_public_path__ + "static/media/icon-error-desktop.78c02ab9.svg";